import { toOptions } from '../utils/labels';
import type { LabelMap } from '../types/common';

export const PAYMENT_MODES: LabelMap = { cash: 'Cash', upi: 'UPI', bank: 'Bank transfer', cheque: 'Cheque', card: 'Card' };
export const PAYMENT_MODE_OPTIONS = toOptions(PAYMENT_MODES);

export const TXN_CATEGORIES: LabelMap = {
  invoice_payment: 'Invoice payment',
  advance: 'Advance',
  purchase_payment: 'Supplier bill payment',
  expense: 'Expense',
  refund: 'Refund',
  salary: 'Salary',
  staff_advance: 'Advance to staff',
  capital: 'Owner added money',
  withdrawal: 'Owner withdrawal',
  other: 'Other',
};

/** How a team member is paid. */
export const PAY_TYPES: LabelMap = { daily: 'Daily wage', monthly: 'Monthly salary' };
export const PAY_TYPE_OPTIONS = toOptions(PAY_TYPES);
